import { defineComponent as _defineComponent } from 'vue'
import {ref, watch} from 'vue'
import { Meetings, Userspaces } from "@busy-human/opt-library"
import { useRoute } from 'vue-router';

type Props = {
    meeting: Meetings.Model
    user: Userspaces.Model
    recipient: Userspaces.Model
    isPayer: boolean
    isLoggedIn: boolean
}
type Emits = {
    (e: 'progress'): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'check-in-success',
  props: {
    meeting: null,
    user: null,
    recipient: null,
    isPayer: { type: Boolean },
    isLoggedIn: { type: Boolean }
  },
  emits: ["progress"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'progress'): void,
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    meeting: Meetings.Model
    user: Userspaces.Model
    recipient: Userspaces.Model
    isPayer: boolean
    isLoggedIn: boolean
}





const userName = ref("")
const recipientName = ref("")

watch(() => props.user, async user => {
    if(user) {
        userName.value = user.name.fullName
    }
}, {immediate: true})

watch(() => props.recipient, async recipient => {
    if(recipient) {
        recipientName.value = recipient.name.fullName
    }
}, {immediate: true})


const __returned__ = { props, emit, userName, recipientName, ref, watch, Meetings, Userspaces, useRoute }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})